module.exports = __webpack_public_path__ + "./kit/docs/img/icon-tutorial.5f11cfcc963810e2191cbd7ab9e8d21d.svg";